export default __webpack_public_path__ + "static/media/CTM.56446133.png";